export const HOME = {
  emergentLink: "home-emergent-link",
  shopNowBtn: "home-shop-now-btn",
  findYourSystemBtn: "home-find-your-system-btn",
  procedureCard: (id) => `home-procedure-card-${id}`,
  newsletterInput: "home-newsletter-input",
  newsletterSubmit: "home-newsletter-submit",
};

export const NAV = {
  logo: "nav-logo",
  shop: "nav-shop",
  finder: "nav-finder",
  refills: "nav-refills",
  lookbook: "nav-lookbook",
  howItWorks: "nav-how-it-works",
  faq: "nav-faq",
  cartBtn: "nav-cart-btn",
  cartCount: "nav-cart-count",
  mobileMenu: "nav-mobile-menu",
};

export const PRODUCT = {
  card: (id) => `product-card-${id}`,
  addToCart: "product-add-to-cart",
  gallery: "product-gallery",
  timeline: "product-timeline",
  timelineStep: (i) => `product-timeline-step-${i}`,
  includedItem: (i) => `product-included-item-${i}`,
  faqTrigger: (i) => `product-faq-trigger-${i}`,
  livePrice: "product-live-price",
  slotOption: (slot, opt) => `product-slot-${slot}-option-${opt}`,
  resetConfig: "product-reset-configurator",
  saveConfig: "product-save-configurator",
  shareLinkInput: "product-share-link-input",
  copyLink: "product-share-copy-link",
};

export const REFILLS_IDS = {
  card: (id) => `refill-card-${id}`,
  addToCart: (id) => `refill-add-${id}`,
  brandFilter: (brand) => `refills-filter-brand-${brand}`,
  categoryFilter: (cat) => `refills-filter-category-${cat}`,
  searchInput: "refills-search",
  clearFilters: "refills-clear-filters",
  detailAddToCart: "refill-detail-add-to-cart",
};

export const CART = {
  drawer: "cart-drawer",
  item: (id) => `cart-item-${id}`,
  itemQtyPlus: (id) => `cart-item-qty-plus-${id}`,
  itemQtyMinus: (id) => `cart-item-qty-minus-${id}`,
  itemRemove: (id) => `cart-item-remove-${id}`,
  subtotal: "cart-subtotal",
  checkoutBtn: "cart-checkout-btn",
  emailInput: "cart-email-input",
  empty: "cart-empty-state",
};

export const FINDER = {
  procedureSelect: "finder-procedure-select",
  procedureOption: (id) => `finder-procedure-option-${id}`,
  dateTrigger: "finder-date-trigger",
  submit: "finder-submit",
  result: "finder-result",
  goToSystem: "finder-go-to-system",
};

export const PAYMENT = {
  successHeading: "payment-success-heading",
  cancelHeading: "payment-cancel-heading",
  successOrderId: "payment-success-order-id",
  backHomeBtn: "payment-back-home-btn",
};
